module.exports = __webpack_public_path__ + "img/map_Z1.5.A.01.1cb2ba0f.svg";